export default __webpack_public_path__ + "models/d8a525dc77d417bd83efb0ccb1cc808d.glb";